<template>
    <div class="is-vertical-center">
        <div class="form">
            <img class="logo" src="/images/logos/logo_white.png">
             <h1 class="title">{{ $t("login.welcome") }} <span>{{ $t("login.home") }}</span></h1>

            <div class="formContent">
              <div class="header">
                <h3>{{ $t("login.recoverPassword") }}</h3>
                <p class="subtitle">{{ $t("login.introEmail") }}</p>
              </div>

              <div class="formElement">
                <label>{{ $t("login.email") }}</label>
                <input :placeholder="$t('login.email')" type="text" v-model="email"/>
              </div>

                <p class="error" v-if="error">{{ error }}</p>
                <p class="error" v-if="message">{{ message }}</p>
            </div>

            <button style="cursor:pointer" :disabled="email.length === 0  || !checkEmail(email)"
                    v-on:click="recoverPassword">{{ $t("login.send") }}
            </button>

            <p class="backtoLogin"><router-link to="/login">{{ $t("login.return")}}</router-link></p>
        </div>
    </div>
</template>

<script>
    import firebase from 'firebase/app'

    export default {
        name: 'passwordRecover',
        data: function () {
            return {
                email: '',
                error: '',
                message: '',
            }
        },
        methods: {

            checkEmail: function (email) {
                // eslint-disable-next-line
                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            },


            recoverPassword: function () {
                if (this.checkEmail(this.email)) {
                    firebase.auth().sendPasswordResetEmail(this.email).then(() => {
                        this.message = this.$t("login.receiveEmail");
                        this.error = '';

                    }).catch(error => {
                        this.message = '';
                        this.error = error.message;

                    });

                } else {
                    alert(this.$t("login.enterValid"));
                }
            }

        },

    }
</script>

<style lang="scss" scoped>

    #app {

      .is-vertical-center {
          height: 100vh;
          background: url("/images/backgrounds/login.jpg") center center;

          .form {
              margin: 0 auto;
              padding: 2vw;
              width: 480px;
              max-width: 100%;

              .logo {
                width: 20%;
              }

              .title {
                  font-size: 2.2em;
                  text-align: center;
                  color: white;
                  font-weight: normal;

                  span {
                    font-weight: bold;
                  }

              }

              .formContent {
                background: #ffffff;
                border: 1px solid gainsboro;
                padding: 0px 20px 10px;
                border-radius: 1vh;
                text-align: left;
                margin-bottom: 1.5rem;

                .formElement {
                  margin: 1rem 0;

                  label, .recoverPassword a {
                    color: #9C9B9B;
                    font-size: 0.8rem;
                    transition: 0.2s ease-in-out color;
                  }
                  input {
                    padding:8px;
                    display:block;
                    border:none;
                    border-bottom:1px solid #9C9B9B;
                    width:100%;
                    transition: 0.2s ease-in-out border;
                  }
                    input:focus {
                      border-bottom:1px solid #2DAB66;
                    }
                  .recoverPassword {
                    float: right;
                  }
                  .recoverPassword a:hover {
                    color: #2DAB66;
                  }

                }
                .error {
                  font-size: 0.8rem;
                  color: #a12d2d;
                  margin-bottom: 2em;
                }

                h3 {
                  text-align: center;
                  padding: 1rem;
                }
                .subtitle {
                    font-size: 0.8em;
                    text-align: center;
                    color: #9C9B9B;
                }
              }

              button {
                background: #2DAB66;
                padding: 5px 15px;
                border-radius: 1vh;
                border: none;
                color: #ffffff;
                font-size: 1.3rem;
                cursor: pointer;
                transition: 0.2s ease-in-out background;
              }
                button:hover {
                  background: #2FBD6F;
                }

              .backtoLogin a{
                color: #ffffff;
                margin-top: 10px;
                font-size: 0.8rem;
                .backtoLogin a:hover {
                  color: #eaeaea;
                }
              }


          }

      }

    }

</style>
